module.exports = __webpack_public_path__ + "img/dmlogo.9f855fee.svg";